/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CustomTooltip } from './tooltip_component';

export const HomePathLeftBarComponent = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <CustomTooltip title="Home">
        <Box sx={{ marginBottom: '10px', color: '#BD1D23', marginTop: '50px', cursor: 'pointer' }}>
          <svg
            onClick={() => navigate('/rov')}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <g clip-path="url(#clip0_3459_18104)">
              <path
                d="M5.85313 0.684375C6.35938 0.684375 6.76875 1.09375 6.76875 1.6V3.79688C6.76875 4.30312 6.35938 4.7125 5.85313 4.7125H1.6C1.09375 4.7125 0.684375 4.30312 0.684375 3.79688V1.6C0.6875 1.09687 1.09687 0.6875 1.6 0.684375H5.85313ZM5.85313 0H1.6C0.715625 0 0 0.715625 0 1.6V3.79688C0 4.68125 0.715625 5.39687 1.6 5.39687H5.85313C6.7375 5.39687 7.45312 4.68125 7.45312 3.79688V1.6C7.45312 0.715625 6.7375 0 5.85313 0Z"
                fill="black"
              />
              <path
                d="M5.85313 7.23125C6.35938 7.23125 6.76875 7.64063 6.76875 8.14688V14.4C6.76875 14.9062 6.35938 15.3156 5.85313 15.3156H1.6C1.09375 15.3156 0.684375 14.9062 0.684375 14.4V8.14688C0.684375 7.64063 1.09375 7.23125 1.6 7.23125H5.85313ZM5.85313 6.54688H1.6C0.715625 6.54688 0 7.2625 0 8.14688V14.4C0 15.2844 0.715625 16 1.6 16H5.85313C6.7375 16 7.45312 15.2844 7.45312 14.4V8.14688C7.45312 7.2625 6.7375 6.54688 5.85313 6.54688Z"
                fill="black"
              />
              <path
                d="M14.4 11.2875C14.9062 11.2875 15.3156 11.6969 15.3156 12.2031V14.4C15.3156 14.9063 14.9062 15.3156 14.4 15.3156H10.1469C9.64063 15.3156 9.23125 14.9063 9.23125 14.4V12.2031C9.23125 11.6969 9.64063 11.2875 10.1469 11.2875H14.4ZM14.4 10.6031H10.1469C9.2625 10.6031 8.54688 11.3188 8.54688 12.2031V14.4C8.54688 15.2844 9.2625 16 10.1469 16H14.4C15.2844 16 16 15.2844 16 14.4V12.2031C16 11.3188 15.2844 10.6031 14.4 10.6031Z"
                fill="#BD1D23"
              />
              <path
                d="M14.4 0.684375C14.9062 0.684375 15.3156 1.09375 15.3156 1.6V7.85313C15.3156 8.35938 14.9062 8.76875 14.4 8.76875H10.1469C9.64063 8.76875 9.23125 8.35938 9.23125 7.85313V1.6C9.23125 1.09375 9.64063 0.684375 10.1469 0.684375H14.4ZM14.4 0H10.1469C9.2625 0 8.54688 0.715625 8.54688 1.6V7.85313C8.54688 8.7375 9.2625 9.45312 10.1469 9.45312H14.4C15.2844 9.45312 16 8.7375 16 7.85313V1.6C16 0.715625 15.2844 0 14.4 0Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_3459_18104">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Box>
      </CustomTooltip>
    </>
  );
};
